import { Button, Image, Typography } from '@smartgift/frontend-toolkit';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { createSearchParams, useNavigate } from 'react-router-dom';

import { PageLayout } from '@hero/components/layouts';
import { ShowMore } from '@hero/components/molecules';
import { configs } from '@hero/configs';
import { ROUTE_PATHS } from '@hero/routes';
import { useGetCSEntries } from '@hero/services/content-stack-service/hooks';
import { cleanObjectEmptyFields } from '@hero/utils';

import * as S from './style';

export function SendGiftOccasionTemplate() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [selectedOccasion, setSelectedOccasion] = React.useState(null);

  const { data: dataGiftTemplates, isLoading } = useGetCSEntries({
    entryCode: 'sgb_dashboard_gift_templates',
    params: {
      asc: 'order'
    }
  });

  const onSelectOccasion = async template => {
    setSelectedOccasion(template);
    navigate({
      pathname: ROUTE_PATHS.SEND_GIFT_CREATE_GIFT_LIST,
      search: `?${createSearchParams(
        cleanObjectEmptyFields({
          collectionIds: template?.product_criteria?.collection_id,
          categoryIds: template?.product_criteria?.category_id,
          brandIds: template?.product_criteria?.brand_id,
          minPrice: template?.product_criteria?.min_price,
          maxPrice: template?.product_criteria?.max_price,
          templateUid: template?.uid,
          templateTitle: template?.title
        })
      )}`
    });
  };

  return (
    <PageLayout
      header={{
        title: t('sendOneTimeGifts'),
        ...(configs?.general?.createWithAI && {
          components: {
            EndContent: () => <S.CreateWithAIButton>{t('createWithAI')}</S.CreateWithAIButton>
          }
        })
      }}
    >
      <S.Content>
        <S.Head>
          <S.HeadLeft>
            <Typography variant="subtitle4SemiBold">{t('chooseAnOccasion')}</Typography>
            <Typography variant="body1">{t('chooseAnOccasionDesc')}</Typography>
          </S.HeadLeft>
          <S.HeadRight>
            <Button
              variant="link"
              color="neutral"
              onClick={() => {
                navigate(ROUTE_PATHS.GIFT_CATALOG);
              }}
            >
              {t('continueWithTheStandardFlow')}
            </Button>
          </S.HeadRight>
        </S.Head>
        <S.ContentInner>
          <ShowMore type="array" numberOfLines={8} container={S.OccasionsList}>
            {isLoading ? (
              <></>
            ) : (
              dataGiftTemplates?.entries
                .filter(t => t.enabled)
                .map(template => (
                  <S.OccasionItem
                    key={template.uid}
                    checked={selectedOccasion?.uid === template.uid}
                    onClick={() => onSelectOccasion(template)}
                  >
                    <Typography variant="body2SemiBold">{template.title}</Typography>
                    <Image src={template.cover_image.url} width="100%" />
                  </S.OccasionItem>
                ))
            )}
          </ShowMore>
        </S.ContentInner>
      </S.Content>
    </PageLayout>
  );
}
